// Where people land (REDESIGN 10): a platform admin (MG) goes straight to the admin view after logging in and
// when opening "/", unless an explicit ?next= says otherwise or the admin asked for the visitor preview.
import { safeNext } from '@/lib/auth'

export const ADMIN_HOME = '/admin'
/** "/?preview=visitor" renders the public home for a logged in admin instead of redirecting. */
export const VISITOR_PREVIEW_PATH = '/?preview=visitor'

/**
 * After a password, email code or Google login: the ?next= target when there is a real one, else /admin for a
 * platform admin and "/" for everyone else. A missing, "/" or unsafe next counts as no next.
 */
export function postLoginPath(rawNext: string | null | undefined, isPlatformAdmin: boolean): string {
  const next = safeNext(rawNext)
  return next === '/' && isPlatformAdmin ? ADMIN_HOME : next
}

/** True when the query string asks for the visitor preview of the home page (?preview=visitor). */
export function isVisitorPreview(search: string | URLSearchParams): boolean {
  const params = typeof search === 'string' ? new URLSearchParams(search) : search
  return params.get('preview') === 'visitor'
}

/** "/" for a logged in platform admin goes to /admin, except in the visitor preview; null means stay. */
export function adminHomeRedirect(isPlatformAdmin: boolean, search: string | URLSearchParams): string | null {
  if (!isPlatformAdmin || isVisitorPreview(search)) return null
  return ADMIN_HOME
}
